import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '_services/user-service';

const initialState = {
    newusers: null,
    status: 'idle',
    verifyStatus: 'idle',
    error: null
};

export const getUsers = createAsyncThunk('user/getUsers', async (params) => {
    return UserService.getAllUsers(params);
});

export const verifyUser = createAsyncThunk('user/updateUserDb', async (userDb) => {
    return UserService.verifyUser(userDb);
});

const newusersSlice = createSlice({
    name: 'newusers',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getUsers.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getUsers.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              newusers: action.payload,
            }
        },
        [getUsers.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [verifyUser.pending]: (state, action) => {
            return {
              ...state,
              verifyStatus: 'loading',
            }
        },
        [verifyUser.fulfilled]: (state, action) => {
            return {
              ...state,
              verifyStatus: 'succeeded',
              newusers: action.payload,
            }
        },
        [verifyUser.rejected]: (state, action) => {
            return {
              ...state,
              verifyStatus: 'failed',
              error: action.error.message,
            }
        },
    }
});

export const selectUserList = (state) => {
    if(state.newusers.newusers == null){ return [] }
    if(state.newusers.newusers.filter == undefined){ return [] }

    let list = [];

    state.newusers.newusers.forEach(user => {
        list.push({
            firebaseId:user.firebaseId,
            airport:user.details.authority
        })
    });

    return list;
};

export const { reset } = newusersSlice.actions;
export const selectNewUsers = state => state.newusers.newusers;
export const selectVerifyStatus = state => state.newusers.verifyStatus;

export default newusersSlice.reducer;
